import React, { Component } from "react";
import PropTypes from "prop-types";
import FormLabel from "@material-ui/core/FormLabel";
import Select from "@material-ui/core/Select";
import "./Form.css";
import validate from "../../utils/validate";
import { withStyles, createMuiTheme } from "@material-ui/core/styles";
import locale from "../../utils/locale";

const styles = theme => ({
  bootstrapSelect: {
    padding: '10px 12px',
    border: '1px solid #ced4da',
    width: "calc(100% - 24px)",
    borderRadius: 4
  }
});

class SelectField extends Component {
  state = {
    error: false,
    errorMessage: ""
  };
  
  componentDidMount() {
    this.validateFn(this.props.value, this.props.required, this.props.regEx);
  }

  componentWillReceiveProps(nextProps) {
    this.validateFn(nextProps.value, nextProps.required, nextProps.regEx)
  }

  handleChange = name => event => {
    const value = event.target.value;
    this.validateFn(value, this.props.required, this.props.regEx);
  };

  validateFn(value, required, regEx) {
    let errorObj = validate(value, required, regEx);
    this.setState(() => errorObj);

    if (this.props.onChanged) {
      this.props.onChanged(value, errorObj.error);
    }
  }

  render() {
    const { label, name, value, dataSource, required, showError, classes } = this.props;
    return (
      <div>
        <FormLabel className="radio-group-label">{label}</FormLabel>
        <Select
          native
          className="custom-select"
          inputProps={{ name: name }}
          value={value}
          onChange={this.handleChange(name)}
          error={this.state.error && showError}
          classes={{select:classes.bootstrapSelect}}
        >
          <option value="">{locale('select')} {label}</option>
          {dataSource.map((item, i) => (
            <option key={item.value} value={item.value}>
              {item.display}
            </option>
          ))}
        </Select>
        {this.state.error && showError ? (
          <span className="error-text">({this.state.errorMessage})</span>
        ) : (
          ""
        )}
      </div>
    );
  }
}

SelectField.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  dataSource: PropTypes.array,
  editable: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  onChanged: PropTypes.func
};

export default withStyles(styles)(SelectField);



// WEBPACK FOOTER //
// ./src/components/form/SelectField.js